import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-widget-confirm-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">
        {{ title | translate }}
      </h4>
    </div>

    <div class="modal-body">
      <label>{{ message | translate }}</label><br>
      <small *ngIf='info' class='text-muted'>{{ info | translate }}</small>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-sm"
              (click)="close.emit(true); activeModal.close(true); $event.stopPropagation()">
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>
      <button ngbAutofocus type="button" class="btn btn-outline-secondary btn-sm"
              (click)="close.emit(false); activeModal.close(false); $event.stopPropagation()">
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class WidgetConfirmDialogComponent {

  @Input() title: string;
  @Input() message: string;
  @Input() info: string;

  @Output() close = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {
  }
}
